export enum EAgentRole {
  AGENT = 'agent',
  IC = 'ic',
}
